export const UXFB_COOKIE_KEY = 'uxfb_card_satisfaction';

export const UXFB_VISITED_OFFERS_LIMIT = 10;
